import { SVGProps } from 'react';

const SvgChevronLeft = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
        <path d="M10.273 4.94 9.333 4l-4 4 4 4 .94-.94L7.22 8l3.053-3.06Z" />
    </svg>
);
export default SvgChevronLeft;
